import React, { useState } from 'react';
import { useField } from 'formik';
import FormBIOi18nBlock from './FormBIOi18nBlock';
import getLangData from '../../../utils/getLangData';
const FormBIOi18n = props => {
  const { name, disabled, description } = props;
  const [field, meta, helpers] = useField(name);
  const [show, setShow] = useState(false);

  return (
    <>
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.chinese_zh_man`}
        label={`Chinese man ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.arabic_ar`}
        label={`Arabic ${description}`}
        RTL={true}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.chinese_zh_can`}
        // label='Chinese can BIO'
        label={`Chinese can ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.deutsch_de`}
        // label='Deutsch BIO'
        label={`Deutsch ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.espanol_es`}
        // label='Espanol BIO'
        label={`Espanol ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.français_fr`}
        // label='Français BIO'
        label={`Français ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.hindi_hi`}
        // label='Hindi BIO'
        label={`Hindi ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.indonesian_id`}
        // label='Indonesian BIO'
        label={`Indonesian ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.italiano_it`}
        // label='Italiano BIO'
        label={`Italiano ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.korean_ko`}
        // label='Korean BIO'
        label={`Korean ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.portugues_pt`}
        // label='Portugues BIO'
        label={`Portugues ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.russian_ru`}
        // label='Russian BIO'
        label={`Russian ${description}`}
      />
      <FormBIOi18nBlock
        disabled={disabled}
        show={show}
        name={`${name}.turkish_tr`}
        // label='Turkish BIO'
        label={`Turkish ${description}`}
      />

      <ShowAllButton show={show} onClick={() => setShow(show => !show)} />
    </>
  );
};

const ShowAllButton = ({ onClick, show }) => (
  <div className='row'>
    <div className='col-xl-3'></div>
    <div className='col-xl-9'>
      {' '}
      <button
        className='btn-label-brand btn btn-bold'
        type='button'
        style={{ marginBottom: '10px' }}
        onClick={() => onClick()}
      >
        {' '}
        {!show ? (
          <>
            {getLangData().fields.show_all_lang}{' '}
            <i className=' flaticon2-arrow-down '></i>{' '}
          </>
        ) : (
          <>
            {getLangData().fields.hide_all}{' '}
            <i className=' flaticon2-arrow-up '></i>
          </>
        )}
      </button>
    </div>
  </div>
);

export default FormBIOi18n;
